import { render, staticRenderFns } from "./FareRegisReqPop.vue?vue&type=template&id=3abb79b6&scoped=true"
import script from "./FareRegisReqPop.vue?vue&type=script&lang=js"
export * from "./FareRegisReqPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abb79b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3abb79b6')) {
      api.createRecord('3abb79b6', component.options)
    } else {
      api.reload('3abb79b6', component.options)
    }
    module.hot.accept("./FareRegisReqPop.vue?vue&type=template&id=3abb79b6&scoped=true", function () {
      api.rerender('3abb79b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/FareRegisReqPop.vue"
export default component.exports